// 3rd parties
import { CloseButton } from "react-bootstrap";
import styled from "styled-components";

import LoaderSpinner from "@/components/ReactBootstrap/LoaderSpinner/LoaderSpinner";
import { useOutside } from "@/hooks/useOutside";
import { useRef } from "react";

const StyledCloseButton = styled(CloseButton)`
  width: 16px;
  height: 16px;
  padding: 0;
  background-size: 16px;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
`;

const RightSideBar = ({ onClose, loading, title, children }) => {
  const sideBarRef = useRef(null);
  useOutside(sideBarRef, () => {
    onClose(false);
  });

  const onCloseClick = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div ref={sideBarRef}>
      <div className="right-sidebar side-info-panel sidebar-fixed mw-100 slideInRight animated snt-right-sidebar">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <h4 style={{ fontWeight: "normal", margin: 0 }}>{title || ""}</h4>
          <StyledCloseButton onClick={onCloseClick} />
        </div>
        <div className="sidebar-inner sidebar-scrollbar pr10">
          <LoaderSpinner loading={loading} />
          {children}
        </div>
      </div>
    </div>
  );
};

export default RightSideBar;
